import classNames from 'clsx';
import { isNumber } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';

import SessionTimer from '@swf/components/SessionTimer/SessionTimer';
import { FeatureFlag, Site } from '@swf/core/enums';
import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';

import RegulatoryHeaderCZ from '../RegulatoryHeaderCZ/RegulatoryHeaderCZ';
import RegulatoryHeaderPA from '../RegulatoryHeaderPA/RegulatoryHeaderPA';
import RegulatoryHeaderPT from '../RegulatoryHeaderPT/RegulatoryHeaderPT';
import RegulatoryHeaderSE from '../RegulatoryHeaderSE/RegulatoryHeaderSE';
import RegulatoryHeaderUS from '../RegulatoryHeaderUS/RegulatoryHeaderUS';

import DKHeaderContent from './DKHeaderContent/DKHeaderContent';
import styles from './SessionHeader.scss';

const licenseContent = {
  [Site.PT]: <RegulatoryHeaderPT />,
  [Site.DK]: <DKHeaderContent />,
  [Site.SE]: <RegulatoryHeaderSE />,
  [Site.CZ]: <RegulatoryHeaderCZ />,
  [Site.USPA]: <RegulatoryHeaderPA />,
  [Site.USMI]: <RegulatoryHeaderUS />,
  [Site.USNJ]: <RegulatoryHeaderUS />,
  [Site.USCO]: <RegulatoryHeaderUS />
};

const SessionHeader: React.FC = () => {
  const site = useSelector(select.cms.getSiteId);
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const { userSessionStartTime } = useSelector(select.account.getLoginLimitInfo);
  const useRam1 = useFeature(FeatureFlag.UseRam1);

  return (
    <>
      <div
        className={classNames(styles.sessionHeader, {
          [styles.us]: [Site.USPA, Site.USMI].includes(site)
        })}
      >
        {isAuthenticated && isNumber(userSessionStartTime) && !useRam1 && (
          <SessionTimer
            className={classNames(styles.sessionDuration, {
              [styles.multilineHeader]: site === Site.SE,
              [styles.multilineSessionHeader]: site === Site.SE
            })}
            showLimit={site === Site.CZ}
          />
        )}
      </div>
      {licenseContent[site]}
    </>
  );
};

export default SessionHeader;
